import React from 'react';
import { motion } from 'framer-motion';
import { AnimatedSection } from './AnimatedSection';
import { CTAButton } from './CTAButton';
import { ShieldCheckIcon } from 'lucide-react';
export function OfferSection() {
  return <AnimatedSection className="py-16 md:py-24 px-4 sm:px-6 stars-bg" data-id="element-109">
      <div className="max-w-2xl mx-auto text-center" data-id="element-110">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="glass-card rounded-3xl p-8 md:p-12 relative overflow-hidden" style={{
        borderColor: 'rgba(212, 168, 83, 0.25)'
      }} data-id="element-111">
          {/* Glow accents */}
          <div className="absolute -top-16 left-1/2 -translate-x-1/2 w-64 h-32 bg-[#D4A853] rounded-full opacity-10 blur-3xl" data-id="element-112" />

          <h2 className="font-display text-2xl md:text-3xl font-bold text-white mb-4 relative z-10" data-id="element-113">
            Obtén el Paquete Completo
          </h2>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-4 relative z-10" data-id="element-114">
            <div className="flex items-center gap-2 text-[#4ECDC4]" data-id="element-115">
              <span className="w-2 h-2 rounded-full bg-[#4ECDC4]" data-id="element-116" />
              <span className="font-semibold" data-id="element-117">
                Suplemento Magnesio Glicinato (60 cápsulas)
              </span>
            </div>
            <span className="hidden sm:block text-gray-600" data-id="element-118">+</span>
            <div className="flex items-center gap-2 text-[#D4A853]" data-id="element-119">
              <span className="w-2 h-2 rounded-full bg-[#D4A853]" data-id="element-120" />
              <span className="font-semibold" data-id="element-121">
                eBook Ritual Nocturno Completo
              </span>
            </div>
          </div>
          <p className="text-gray-400 mb-2 relative z-10" data-id="element-122">
            Suplemento + Guía Digital + Checklist + Diarios + Bono de Rescate
          </p>
          <p className="text-gray-300 mb-8 relative z-10" data-id="element-123">
            Deja de sobrevivir a base de café y empieza a vivir con energía
            real.
          </p>

          <div className="mb-8 relative z-10" data-id="element-124">
            <span className="text-gray-500 text-sm uppercase tracking-widest" data-id="element-125">
              Inversión única — Todo incluido
            </span>
            <div className="flex items-baseline justify-center gap-1 mt-2" data-id="element-126">
              <span className="font-display text-5xl md:text-6xl font-bold text-[#D4A853]" data-id="element-127">
                $19.99
              </span>
              <span className="text-gray-400 text-xl" data-id="element-128">USD</span>
            </div>
          </div>

          <div className="relative z-10" data-id="element-129">
            <CTAButton data-id="element-130" />
          </div>

          <div className="flex flex-col items-center gap-2 mt-6 relative z-10" data-id="element-131">
            <div className="flex items-center gap-2" data-id="element-132">
              <ShieldCheckIcon className="w-4 h-4 text-[#4ECDC4]" data-id="element-133" />
              <p className="text-sm text-gray-400" data-id="element-134">
                Compra segura. Acceso instantáneo en PDF tras el pago.
              </p>
            </div>
            <a href="https://vitalizateahora.com/products/magnesium-glycinate-capsules-magnesio-glicinato-para-salud-diaria-y-mejor-sueno-60-ct" target="_blank" rel="noopener noreferrer" className="text-sm text-[#4ECDC4] hover:text-[#D4A853] transition-colors underline underline-offset-2" data-id="element-135">
              Más información sobre el producto →
            </a>
          </div>
        </motion.div>

        {/* Product image below */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mt-12" data-id="element-136">
          <img src="https://cdn.magicpatterns.com/uploads/aGnaDi5jAKiRskLtNZpwAt/download_(3).png" alt="Magnesium Glycinate - Vitalízate Ahora" className="w-48 mx-auto product-glow" data-id="element-137" />
        </motion.div>
      </div>
    </AnimatedSection>;
}